import React from "react";
import { connect } from "react-redux";
import { toggleModal } from "../store/common";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getTranslate } from "react-localize-redux";
import { history } from "../components/App";

const ConfirmOrderModal = ({ getModalStatus, toggleModal, translate }) => (
  <Modal
    size="lg"
    isOpen={getModalStatus}
    toggle={() => toggleModal("order_confirmation_successful", false)}
    className=""
    centered={true}
  >
    <ModalHeader>
      {translate("routes.productList.summaryContainer.modal_info")}
    </ModalHeader>
    <ModalBody>
      <p>{translate("routes.productList.summaryContainer.order_success")}</p>
    </ModalBody>
    <ModalFooter>
      <Button
        color="secondary"
        onClick={() => toggleModal("order_confirmation_successful", false)}
      >
        Ok
      </Button>
    </ModalFooter>
  </Modal>
);

ConfirmOrderModal.propTypes = {};

const mapStateToProps = ({ common, cart, customer, locale }) => ({
  translate: getTranslate(locale),
  getModalStatus: common.modals.order_confirmation_successful
    ? common.modals.order_confirmation_successful
    : null
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => {
    dispatch(toggleModal(modalName, action));
    history.push("/");
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmOrderModal);



// WEBPACK FOOTER //
// ./src/containers/ConfirmOrderModal.js